import React from 'react';

type PageTitleContextValue = {
  pageTitle: string | null;
  setPageTitle: (title: string | null) => void;
};

const PageTitleContext = React.createContext<PageTitleContextValue>({
  pageTitle: null,
  setPageTitle: () => undefined,
});

export function PageTitleProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const [pageTitle, setPageTitle] = React.useState<string | null>(null);
  const value = React.useMemo(
    () => ({ pageTitle, setPageTitle }),
    [pageTitle],
  );
  return <PageTitleContext.Provider value={value}>{children}</PageTitleContext.Provider>;
}

export function usePageTitleContext(): PageTitleContextValue {
  return React.useContext(PageTitleContext);
}

/** Overrides the route-derived tab title while this component is mounted. */
export function usePageTitle(title: string | null | undefined): void {
  const { setPageTitle } = usePageTitleContext();
  React.useEffect(() => {
    const next = title?.trim();
    setPageTitle(next ? next : null);
    return () => setPageTitle(null);
  }, [title, setPageTitle]);
}
